//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.DialogsOrganizacniJednotka.ts						</Name>
//    <Description> Funkce pro otev�en� dialog� spojen�ch s Organiza�n� jednotka </Description>
//    <Author>      FFIALA													</Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2020                            </Copyright>
//    <Created>     2020-08-11                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=484.75.1
//AdtGeneratorConfig:[ T:(ginsorj) GID:(Web.Dia.Ts) V1:(ixs_orj,aktivita,poznamka,dat_od,dat_do,dat_zmena,zmenu_prov,zkratka,nazev,ixs_nad,ofic_nazev) V2:() K1:() K2:() ]

namespace Gordic.Adm.Dialogs {

    // OrganizacniJednotka
    export function DetailOrganizacniJednotkaDlg(
        parentContent: GContent,
        opt: {
            /** ixs_orj */
            ixs_orj: string | null,
            /** grid jquery element */
            grid?: JQuery<HTMLElement> /*| Gordic.Components.GridRC<any>*/,
            /** p��znak nov�ho z�znamu */
            newRecord?: boolean,
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

    const deferred = $.Deferred();
    const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
    ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

    let isValid = true;
    var detailCommand = opt.grid ? false : true;

    // grid remote control, kv�li �ipk�m na detailu
    const gridRemoteControl = opt && opt.grid ? new Gordic.Components.GridRC(opt.grid) : undefined;

    var detail = ['Gordic.Adm.WebControls.DetailOrganizacniJednotka', { gridRemoteControl: gridRemoteControl }]

    const options = {
        ID: "AdmOrganizacniJednotka#",
        ixs_orj: opt ? opt.ixs_orj : undefined,
        newRecord: opt ? opt.newRecord : undefined,
        gridCssClass: opt ? opt.grid?.ggrid("option", "virtualCssClass") : undefined,
        detailCommand: detailCommand
    };

    if (isValid) {
        //RC 32131033 : Detail
        Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
    } else {
        deferred.reject();
    }
    return deferred.promise();
}

    // OrganizacniJednotka
    export function SeznamOrganizacniJednotkaDlg(
        parentContent: GContent,
        opt: {
            /** ixs_orj */
            ixs_orj: string | null,
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

    const deferred = $.Deferred();
    const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
    ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

    let isValid = true;

    var detail = ['Gordic.Adm.WebControls.SeznamOrganizacniJednotka', { }]

    const options = {
        ID: "AdmOrganizacniJednotka#",
        ixs_orj: opt ? opt.ixs_orj : undefined,
    };

    if (isValid) {
        //RC 32131033 : Detail
        Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
    } else {
        deferred.reject();
    }
    return deferred.promise();
  }

}
